import { ValidationNameCell } from 'components/common/Tables/Cells/ValidationNameCell';
import { ComplianceColorDot } from 'components/common/Tables/Cells/ComplianceColorDot';
import { CustomizedTooltip } from 'components/common';
import classes from 'components/widgets/CategoryTable/CategoryTable.module.scss';
import { LogicQualityCheckCardWidget } from 'components/widgets/LogicQualityCheckCardWidget/LogicQualityCheckCardWidget';
import React from 'react';

export const categoryColumns = (category, inScoreNumber, projectId, contractId, versionName, fileMetaDataId) => {
    return [
        {
            Header: 'Validation Type',
            accessor: 'validationName',
            width: 410,
            Cell: ({ value, row }) => {
                const safeValue = value.replace('/', '_');
                const isDCMA: boolean = row.original.dcma;
                return <ValidationNameCell value={value} safeValue={safeValue} isDCMA={isDCMA} category={category} />;
            },
        },
        {
            Header: 'Compliance',
            id: 'status',
            accessor: (rowOriginal) => (rowOriginal.mandatory ? rowOriginal.status : undefined),
            Cell: ({ value }) => <ComplianceColorDot value={value} />,
            width: 180,
        },
        {
            Header: 'Result',
            accessor: 'result',
            width: 200,
        },

        {
            Header: 'Target Threshold',
            accessor: 'threshold',
            width: 200,
        },
        {
            Header: 'Score Deduction',
            accessor: 'negativeScoreImpact',
            Cell: ({ value }) => (
                <CustomizedTooltip
                    triggerElement={
                        <div className={classes.scoreDeduction}>{value === 0 || value === null ? '' : value * -1}</div>
                    }
                    tooltipContent={`100 / ${inScoreNumber} active checks`}
                />
            ),
            width: 200,
        },
        {
            Header: 'Status',
            id: 'cardWidget',
            accessor: 'associatedCard.status.label',
            Cell: ({ row }) => {
                return (
                    <LogicQualityCheckCardWidget
                        projectId={projectId}
                        contractId={contractId}
                        versionName={versionName}
                        cardId={row.original.associatedCard?.cardId}
                        status={row.original.associatedCard?.status}
                        assignee={row.original.associatedCard?.assignee}
                        title={row.original.validationName}
                        metaDataId={fileMetaDataId}
                        checkId={row.original.validationId}
                    />
                );
            },
            width: 215,
        },
    ];
};
